import { AliasProduct, AliasProductInput } from "../types/AliasProduct";
import { Hint } from "@/ui/Hint";
import { notify } from "@/ui/chakra/notify";
import AliasProductForm from "./AliasProductForm";
import { useUpdateAliasProduct } from "../useCases/useUpdateAliasProduct";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";

interface EditAliasProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedAliasProduct: AliasProduct;
}

export const EditAliasProductModal = ({
  isOpen,
  onClose,
  selectedAliasProduct,
}: EditAliasProductModalProps) => {
  const { mutate } = useUpdateAliasProduct();

  const handleUpdateAliasProduct = (data: AliasProductInput) => {
    mutate(
      {
        id: selectedAliasProduct.id,
        updateAliasProducts: data,
      },
      {
        onSuccess: () => {
          notify.success("Alias actualizado");
          onClose();
        },
        onError: (error) =>
          notify.error("No se pudo actualizar el alias", error),
      },
    );
  };

  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Editar alias de producto</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody pb={0} display="flex" flexDirection="column" gap={5}>
          <Hint>
            Un alias es otro nombre o código para buscar un producto que ya
            existe, por ejemplo el que usa el cliente o el proveedor. Al
            elegirlo en un vale se agrega el producto real.
          </Hint>
          <AliasProductForm
            onSubmit={handleUpdateAliasProduct}
            onCancel={onClose}
            selectedAliasProduct={selectedAliasProduct}
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
